import { User } from '../models/Organization'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getIDToken } from '../utils/AuthUtil'
import { addUser, addUsers } from '../actions/auth'
import {
  addClients,
  addFiles,
  updateSelectedOrganization,
  addUserRecentFiles,
  updateUser,
  addProjects,
} from '../actions/organization'
import { BASE_URL } from '../config'
import {
  fetchAdminAssignedProjects,
  fetchEngineerAssignedProjects,
} from './reviewService'
import { UserRoleNames } from '../models/AccessControl'

export const addUserAsync = createAsyncThunk(
  'organization/adduser',
  async (
    user: { organization_id: number; role_id: number | null; email: string },
    { dispatch },
  ) => {
    return fetch(`${BASE_URL}/api/users/create`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    }).then((response) => {
      if (!response.ok)
        return response.json().then((response) => {
          throw new Error(response.error)
        })
      return response.json()
    })
  },
)

export const fetchUserOrganizationAsync = createAsyncThunk(
  'organization/findUserOrganization',
  async (payload: { userId: string }, { dispatch }) => {
    if (!payload.userId) return
    return fetch(`${BASE_URL}/api/users/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filterBy: [
          {
            name: 'cognito_user_id',
            value: payload.userId ? payload.userId : null,
          },
        ],
        include: {
          organization: {
            include: {
              Client: {
                include: {
                  Project: {
                    include: {
                      File: true,
                    },
                  },
                },
              },
            },
          },
          recentFiles: {
            orderBy: {
              updatedAt: 'desc',
            },
            include: {
              file: {
                include: {
                  project: {
                    include: {
                      File: true,
                    },
                  },
                },
              },
            },
          },
          role: {
            include: {
              AccessPolicy: {
                include: {
                  attribute: true,
                },
              },
            },
          },
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const user = data?.find(Boolean)
        if (user) {
          const organization = user.organization
          const recentFiles = user.recentFiles
          const organizationClients = organization?.Client
          /*const selectedOrganizationClient = organizationClients?.find(Boolean)
          const organizationClientProjects = selectedOrganizationClient?.Project
          const selectedOrganizationClientProject =
            organizationClientProjects?.find(Boolean)
          const organizationClientProjectFiles =
            selectedOrganizationClientProject?.File*/
          dispatch(addUser(user))
          dispatch(updateSelectedOrganization(organization))
          //dispatch(updateSelectedClient(selectedOrganizationClient))
          dispatch(addClients(organizationClients))
          /*dispatch(
            addClientProjects({
              clientId: selectedOrganizationClient.id!,
              projects: organizationClientProjects,
            }),
          )*/
          //dispatch(updateSelectedProject(selectedOrganizationClientProject))
          const projects = organizationClients.flatMap(
            (client: any) => client?.Project,
          )
          const files = organizationClients.flatMap((client: any) =>
            client?.Project.flatMap((project: any) => project.File),
          )
          dispatch(addProjects(projects))
          dispatch(addFiles(files))
          dispatch(addUserRecentFiles(recentFiles))
          dispatch(fetchUsersAsync({ organizationId: organization?.id! }))

          if (user.role.name === UserRoleNames.EngineeringAdmin) {
            dispatch(
              fetchAdminAssignedProjects({
                organization_id: organization?.id!,
              }),
            )
          }
          if (
            user.role.name === UserRoleNames.LeadingStructuralEngineer ||
            user.role.name === UserRoleNames.LeadingElectricalEngineer ||
            user.role.name === UserRoleNames.StructuralEngineer ||
            user.role.name === UserRoleNames.ElectricalEngineer
          ) {
            dispatch(
              fetchEngineerAssignedProjects({
                organization_id: organization?.id!,
                user_id: user.id,
              }),
            )
          }
        }
      })
      .catch((error) => console.error('Error during fetching clients: ', error))
  },
)

export const fetchUsersAsync = createAsyncThunk(
  'user/findUsers',
  async (payload: { organizationId: string }, { dispatch }) => {
    return fetch(`${BASE_URL}/api/users/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filterBy: [
          {
            name: 'organization_id',
            value: payload.organizationId ? payload.organizationId : null,
          },
        ],
        include: {
          role: true,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(addUsers(data))
      })
      .catch((error) => console.error('Error during fetching users: ', error))
  },
)

export const updateUserAsync = createAsyncThunk(
  'user/update',
  async (payload: { userId: number; info: object }, { dispatch }) => {
    return fetch(`${BASE_URL}/api/users/update`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: payload.userId,
        data: payload.info,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(updateUser({ userId: data.id, newInfo: data }))
      })
      .catch((error) => console.error('Error during updating user: ', error))
  },
)
